import { useEffect, useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { TID } from '@/constants/testIds';
import { BRAND } from '@/constants/content';

const NAV = [
    { id: 'home', label: 'Home', tid: TID.navHome },
    { id: 'about', label: 'About', tid: TID.navAbout },
    { id: 'founders', label: 'Founders', tid: TID.navFounders },
    { id: 'services', label: 'Services', tid: TID.navServices },
    { id: 'process', label: 'Process', tid: TID.navProcess },
    { id: 'contact', label: 'Contact', tid: TID.navContact },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? 'backdrop-blur-xl bg-white/85 border-b border-hairline shadow-soft'
                    : 'bg-white/60 backdrop-blur-md border-b border-transparent'
            }`}
        >
            <div className="container-wl flex items-center justify-between h-20">
                <button
                    onClick={() => go('home')}
                    data-testid={TID.headerLogo}
                    className="flex items-center gap-3 group"
                    aria-label="Waylthlane Financials home"
                >
                    <img
                        src={BRAND.logoUrl}
                        alt="Waylthlane Financials"
                        className="h-14 w-14 object-contain"
                        loading="eager"
                    />
                    <div className="hidden sm:flex flex-col leading-tight text-left">
                        <span className="font-display-bold text-[28px] text-ink tracking-tight">
                            Waylthlane
                        </span>
                        <span className="text-[10px] uppercase tracking-widest2 text-gold-600">
                            Investment Reimagined
                        </span>
                    </div>
                </button>

                <nav className="hidden lg:flex items-center gap-9">
                    {NAV.map((n) => (
                        <button
                            key={n.id}
                            data-testid={n.tid}
                            onClick={() => go(n.id)}
                            className="relative text-[13.5px] font-medium text-ink/80 hover:text-ink transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[1.5px] after:w-0 after:bg-gold after:transition-all hover:after:w-full"
                        >
                            {n.label}
                        </button>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <button
                        onClick={() => go('contact')}
                        data-testid={TID.headerCta}
                        className="hidden md:inline-flex btn-primary !py-3 !px-5 !text-[11px]"
                    >
                        Book Consultation
                        <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                    <button
                        onClick={() => setOpen((s) => !s)}
                        data-testid={TID.mobileMenuToggle}
                        className="lg:hidden p-2 text-ink"
                        aria-label="Toggle menu"
                    >
                        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden bg-white border-t border-hairline">
                    <div className="container-wl py-6 flex flex-col gap-4">
                        {NAV.map((n) => (
                            <button
                                key={n.id}
                                onClick={() => go(n.id)}
                                className="text-left text-base text-ink/85 hover:text-gold transition-colors py-2"
                            >
                                {n.label}
                            </button>
                        ))}
                        <button onClick={() => go('contact')} className="btn-primary mt-2">
                            Book Consultation
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
